<template>
  <div class="order">
    <search :recordsSearchObj="recordsSearchObj" @handleSearch="handleSearch" />
    <el-tabs
      v-model="activeName"
      class="tabs-container"
      @tab-click="handleClick"
    >
      <el-tab-pane label="全部" name="all"></el-tab-pane>
      <el-tab-pane label="待受理" name="0"></el-tab-pane>
      <el-tab-pane label="受理中" name="1"></el-tab-pane>
      <el-tab-pane label="已关闭" name="2"></el-tab-pane>
      <el-tab-pane label="已取消" name="3"></el-tab-pane>
    </el-tabs>
    <div class="table-container">
      <div class="table-btn" >
        <el-button
          type="text"
          icon="el-icon-download"
          @click="handleExport"
          :loading="exportLoading"
          >导出</el-button
        >
      </div>
      <el-table
        :data="tableData"
        border
        stripe
        highlight-current-row
        v-loading="loading"
      >
        <el-table-column type="selection" width="40" align="center">
        </el-table-column>
        <el-table-column type="index" label="序号" width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="consultNum"
          label="咨询工单号"
          align="center"
          min-width="120"
        >
        </el-table-column>
        <el-table-column
          prop="consultSubject"
          label="咨询主题"
          min-width="350"
        >
        </el-table-column>
        <el-table-column
          prop="customerName"
          label="客户名称"
          min-width="160"
        >
        </el-table-column>
        <el-table-column
          prop="customerAccountNum"
          label="客户账号"
          align="center"
          min-width="100"
        >
        </el-table-column>

        <el-table-column
          prop="customerCountry"
          label="国家"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <p>{{ getCountry(scope.row.customerCountry) }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="carBrand"
          label="品牌"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="carModel"
          label="车型"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="suspectedCulpritName"
          label="疑似/祸首件名称"
          min-width="150"
        >
        </el-table-column>
        <el-table-column
          prop="suspectedCulpritCode"
          label="疑似/祸首件代码"
          min-width="190"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="咨询时间"
          align="center"
          width="160"
        >
        </el-table-column>
        <el-table-column
          prop="status"
          label="问题状态"
          min-width="90"
          show-overflow-tooltip
          align="center"
        >
          <!-- getStatus -->
          <template slot-scope="scope">
            <p>{{ getStatus(scope.row.status) }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="replyOrNotResult"
          label="是否回复"
          min-width="90"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="staffName"
          label="回复人"
          align="center"
          min-width="120"
        >
        </el-table-column>
        <el-table-column
          prop="lastInquiryTime"
          label="最后留言时间"
          align="center"
          width="160"
        >
        </el-table-column>
        <el-table-column
          prop="lastReplyTime"
          label="最后回复时间"
          align="center"
          width="160"
        >
        </el-table-column>
        <el-table-column
          prop="timeDifference"
          label="回复时间差"
          align="center"
          :min-width="100"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="80px"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="toDetail(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye" v-show="total > 0">
        <pagination
          :total="total"
          :page.sync="page"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { seekList, seekExport } from "@/api/seek";
import search from "@/components/seekSearch";
import { getNations } from "@/util/getNation";
import { setStorage } from "@/util/localStor";
import { getDownloadFiles } from "@/util/downFile";

export default {
  components: {
    search
  },
  data() {
    const { data, pageNum, pageSize } = this.$route?.query?.searchObj
      ? JSON.parse(this.$route?.query?.searchObj)
      : {};
    return {
      activeName: "all",
      tableData: [],
      page: Number(pageNum) || 1,
      pageSize: Number(pageSize) || 10,
      total: 0,
      searchInfo: {},
      loading: false,
      exportLoading: false,
      recordsSearchObj: data
    };
  },
  mounted() {
    this.searchInfo = this.recordsSearchObj
      ? JSON.parse(JSON.stringify(this.recordsSearchObj))
      : this.searchInfo;
    delete this.searchInfo.date;
    this.activeName = this.recordsSearchObj?.status || "all";
    this.getList();
  },
  methods: {
    getStatus(data) {
      let status;
      if (data == 0) status = "待受理";
      if (data == 1) status = "受理中";
      if (data == 2) status = "已关闭";
      if (data == 3) status = "已取消";
      return status;
    },
    getCountry(data) {
      let country = getNations(data);
      return country;
    },
    handleSearch(data, type) {
      if (type === "reset") {
        this.activeName = "all";
        this.searchInfo.status = "";
      }
      // consultNum:'',
      //   customerName:'',
      //   customerAccountNum: '',
      //   countryId:'',
      //   suspectedCulpritName: '',
      //   suspectedCulpritCode: '',
      //   carBrand: '',
      //   carModel: '',
      let obj = data;
      this.searchInfo.consultNum = obj.consultNum;
      this.searchInfo.customerName = obj.customerName;
      this.searchInfo.customerAccountNum = obj.customerAccountNum;
      // this.searchInfo.countryId=obj.countryId
      obj.countryId == "0"
        ? (this.searchInfo.countryId = "")
        : (this.searchInfo.countryId = obj.countryId);
      this.searchInfo.suspectedCulpritName = obj.suspectedCulpritName;
      this.searchInfo.suspectedCulpritCode = obj.suspectedCulpritCode;
      this.searchInfo.carBrand = obj.carBrand;
      this.searchInfo.carModel = obj.carModel;
      this.searchInfo.replyOrNot = obj.replyOrNot;
      this.page = 1;
      this.pageSize = 10;
      if (obj.date) {
        this.searchInfo.createTimeStart = obj.date[0] + " 00:00:00";
        this.searchInfo.createTimeEnd = obj.date[1] + " 23:59:59";
      } else {
        this.searchInfo.createTimeStart = "";
        this.searchInfo.createTimeEnd = "";
      }

      // this.searchInfo = data
      // delete this.searchInfo.date
      this.getList();
    },
    handleClick(tab) {
      this.page = 1;
      this.pageSize = 10;
      this.searchInfo.status = tab.name === "all" ? "" : tab.name;
      this.getList();
    },
    async getList() {
      this.loading = true;
      let query = {
        data: {
          ...this.searchInfo
        },
        page: {
          pageNum: this.page,
          pageSize: this.pageSize
        }
      };
      const res = await seekList(query);
      if (res.status == 0) {
        this.tableData = res.data.records;
        this.total = res.data.count;
        this.loading = false;
      }
    },
    // 分页
    handlePaginationChange(val) {
      this.page = val.page;
      this.pageSize = val.limit;
      this.getList();
    },
    toDetail(row) {
      this.$router.replace(
        "/seek?searchObj=" +
          JSON.stringify({
            data: {
              ...this.searchInfo,
              date: this.searchInfo.createTimeStart
                ? [
                    this.searchInfo.createTimeStart.split(" ")[0],
                    this.searchInfo.createTimeEnd.split(" ")[0]
                  ]
                : ""
            },
            pageNum: this.page,
            pageSize: this.pageSize
          })
      );
      this.$router.push({
        name: "seekDetail",
        query: { seeId: row.consultNum }
      });
      setStorage("seekData", row);
    },
    async handleExport() {
      this.exportLoading = true;
      let query = {
        data: {
          ...this.searchInfo
        }
      };
      try {
        const res = await seekExport(query);
        getDownloadFiles(res);
        if (res.fileName) {
          this.$DonMessage.success("导出成功！");
        }
      } catch (error) {}
      this.exportLoading = false;
    }
  }
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
